import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3l3 -6","key":"svg-0"}]]

/**
 * IconFlare
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZmxhcmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDNsMyA2bDYgM2wtNiAzbC0zIDZsLTMgLTZsLTYgLTNsNiAtM2wzIC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/flare
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFlare = createReactComponent('outline', 'flare', 'Flare', __iconNode);

export default IconFlare;